import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=7ed4d977&scoped=true"
import script from "./VirtualScroller.vue?vue&type=script&lang=js"
export * from "./VirtualScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed4d977",
  null
  
)

export default component.exports